<template>
  <div class="w-full bg-[#146297]">
    <div class="grid md:container">
      <div class="mx-3 lg:mx-12 mt-4 md:mt-8 mb-8 md:mb-16">
        <div v-if="hasText || (hasTitle && show_title)" class="mx-auto flex flex-col gap-2 mt-3 mb-2.5">
          <h1 v-if="hasTitle && show_title" v-html="title"
              class="text-white text-3xl leading-8 lg:text-5xl text-center font-bold"></h1>
        </div>

        <!-- <div v-if="hasCountHeading" class="container mx-auto md:flex md:flex-col md:gap-2"> -->
        <div v-if="hasCountHeading">
          <div class="text-white text-lg leading-6 text-center font-normal">
            <div v-if="hasCountHeading" class="count-heading mt-4 md:mt-8 mb-6 md:mb-12" v-html="count_heading"></div>
          </div>
        </div>
        <div v-if="hasSysKeyValue" class="bg-white border border-white pb-8 md:pb-12 rounded-3xl px-4">
          <div class="mx-auto flex flex-col gap-2 lg:px-8">
            <p v-html="sysKeyValue['box_heading']"
                class="text-center text-xl lg:text-3xl text-[#146297] font-bold my-5 md:my-8"></p>
          </div>
          <div class="flex flex-col lg:flex-row justify-around gap-2 px-2">
            <input-button
                :disabled="fetching"
                block
                class="w-auto"
                styleType="search-county-town"
                as="button"
                @onClick="onSearch('cnd')"
            >
              <p v-html="sysKeyValue['box_cnd_button_text']"></p>
            </input-button>

            <input-button
                :disabled="fetching"
                block
                class="w-auto"
                styleType="search-county-town"
                as="button"
                @onClick="onSearch('emp')"
            >
              <p v-html="sysKeyValue['box_emp_button_text']"></p>
            </input-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show_description && hasText"
       class="container mx-auto flex flex-col gap-2 pagetext-content mt-12 mb-8">
    <div class="page-description">
      <ReadMore v-if="show_description && hasText" :text="topText"></ReadMore>
    </div>
  </div>
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import IconArrowCircle from 'Components/Icons/IconArrowCircle';
import validates, {validators} from 'Mixins/validates';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import uuid from 'Mixins/uuid';
import locations from 'Helpers/locations.json';
import ReadMore from "Components/PageText/ReadMore.vue";

export default {
  name: 'SearchBar',
  components: {
    IconArrowCircle,
    InputButton,
    ReadMore,
  },
  mixins: [validates, uuid],
  props: {
    pageType: {
      type: String,
      default: 'home',
      validator(value) {
        return ['search', 'home', 'article'].includes(value);
      },
    },
    industry: {
      type: String,
      default: null,
    },
    skill: {
      type: String,
      default: null,
    },
    location: {
      type: Object,
      default: null,
    },
    job_type: {
      type: String,
      default: 'any',
    },
    emp_cand: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      locationOptions: locations,
    };
  },
  computed: {
    ...mapState('search', ['fetching']),
    ...mapGetters('search', ['currentLocationOption', 'searchQuery']),
    ...mapGetters('pagetext', ['hasCountHeading']),
    ...mapState('pagetext', ['topText', 'title', 'show_title', 'show_description', 'count_heading', 'sysKeyValue']),
    hasText() {
      return this.topText != '';
    },
    hasTitle() {
      return this.title != '';
    },
    hasSysKeyValue() {
      return this.sysKeyValue != '';
    },
  },
  methods: {
    ...mapActions('industry', ['getIndustrySkills']),
    ...mapActions('search', ['doSearch']),
    ...mapMutations('search', ['setParameter']),
    ...mapMutations('contact', { setRequestorType: 'setType' }),
    searchURLFor(type) {
        let p = this.searchQuery;
        p.emp_cand = type;
        let url = this.$router.resolve({
            name: 'search',
            query: p
        });
        //url = url + '?' + p.join('&');
        return encodeURI(url.href);
    },
    async onSearch(emp_cand) {
      this.resetErrors();
      this.changeParameter('emp_cand', emp_cand);

      // Allow the dom to render the no error state before validating again so error messages
      // properly popup
      await this.$nextTick();
      if (
          !this.validate(
              {
                industry: [validators.required],
                emp_cand: [validators.required],
              },
              {
                industry: this.industry,
                emp_cand: this.emp_cand,
              }
          )
      ) {
        return;
      }
      // always ensure the cookie syncs to the form on submit
      this.setRequestorType(emp_cand);

      this.changeParameter('page', 1);

      jQuery(document).trigger('tc_search');
      
      this.link_to({
        name: 'search',
        query: this.searchQuery,
      }, true);
    },
    changeParameter(key, value) {
      delete this.errors[key];
      this.setParameter({key, value});
    }
  },
};
</script>
